import { render, staticRenderFns } from "./Ingrediente.vue?vue&type=template&id=7dfb86f0&"
import script from "./Ingrediente.vue?vue&type=script&lang=js&"
export * from "./Ingrediente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports